<script lang="ts">
    import { Similarjobs } from "../../../../utils/Constant/Constant";
    import { Badge, Card, CardBody, Col, Image,  Row} from "sveltestrap";
    import {cardjobsearch} from "../../../../Data/Miscellaneous/CardView"
    import Link from "svelte-link";
    import { href } from "../../../../utils/Constant/Constant";
    import CardRating from "../CardsView/CardRating.svelte";
    let imgPath:string = "/assets/images/job-search"
</script>
<div class="header-faq">
    <h6 class="mb-0 f-w-600">{Similarjobs}</h6>
</div>
<Row>
    {#each cardjobsearch.slice(0,5) as cardItem}
      <Col xl={cardItem.title == "Graphic designer" ? "12" : "6"} class="xl-100 box-col-12">
        <Card class="{cardItem.rclass}">
            {#if cardItem.rclass}
                <div class="ribbon ribbon-bookmark ribbon-vertical-left ribbon-secondary">
                    <i class="icofont icofont-love"></i>
                </div>
            {/if}
            <div class="job-search">
                <CardBody>
                    <div class="media">
                        <Image fluid class="img-40 m-r-20" src="{imgPath}/{cardItem.img}"  />
                        <div class="media-body">
                            <h6 class="f-w-600">
                                <Link href={href}>{cardItem.title}</Link>
                                {#if cardItem.badge}
                                    <Badge color="primary" class="pull-right">{cardItem.badge}</Badge>
                                {/if}
                                {#if cardItem.date}
                                    <span class="pull-right">{cardItem.date}</span>
                                {/if}
                            </h6>
                            <p>{cardItem.subtitle}</p>
                            <CardRating />
                        </div>
                    </div>
                    <p>{cardItem.detail}</p>
                </CardBody>
            </div>
        </Card>
      </Col>
    {/each}
</Row>